export default "__VITE_ASSET__3430819d__"